import type { ApiInstance } from "~/plugins/api";

export const useApi = (): ApiInstance => {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$api;
};
